<template>
  <div class="ch-main">
    <el-carousel v-if="false" trigger="click"
                 height="400px">
      <el-carousel-item v-for="(item,index) in banners"
                        :key="index">
        <el-image :src="item.imgUrl"
                  style="width:100%; height:100%"
                  @click="isSkip(item)"></el-image>
      </el-carousel-item>
    </el-carousel>
    <div class="ch-container">
      <div class="ch-title">关于我们</div>
      <div v-html="chContent"
           class="ch-content">
        <!--        <p>秉承“激扬商业之美”的使命，张利江先生创立了易招标，致力于招投标领域的数字化转型，推动交易成本持续下降，从而促进供应链的效率提高，并充分利用整个社会的交易资源，打造“互联网+招投标”生态圈。</p>-->
        <!--        <p>张利江先生是中国知名的招标采购供应链专家。基于对顶层制度的深刻理解，他从2000年开始研究招投标法律，并在当年即参与国家经贸委招标立法和管理工作，参与起草了《招标投标法实施条例》、《机电产品国际招标投标实施办法》，并协助国家发改委设计制定《电子招标投标办法》及后续该领域几乎所有的规范性文件。</p>-->
        <!--        <p>张利江先生曾创立宝钢集团旗下宝华招标，并任董事总经理多年。期间使公司获取了全系列招标代理资质，建立了集团招投标管理制度，建成中国第一套全流程互联网招投标平台，连续三年荣获全国“十大最受欢迎招标代理机构”和“十大最具竞争力招标代理机构”。他是中国第三方电子招投标交易平台的设计者和开拓者。</p>-->
        <!--        <p>“易招标”是上海汇招信息技术有限公司的简称，是我国唯一集供应链管理咨询、项目实施、平台运营于一体的“互联网+”招标采购综合服务商。我们以招投标法务、招采业务和互联网技术三重叠加的独特优势为核心，提供专业招标采购整体解决方案，招标采购互联网平台运营和招标采购供应链专业咨询服务。公司总部位于上海，在北京、广州、河北、山西设有分支机构，是我国电子招标采购领域的领导者。</p>-->
        <!--        <p>易招标提供全流程线上招标采购解决方案，可以帮助企业实现采购交易的全过程数字化，彻底告别纸质文件。易招标拥有最多《财富》500强中国客户，覆盖金融、冶金和能源等多个领域，客户包括建设银行、太平洋保险、中国人保集团、民生银行、平安银行、武钢集团、马钢集团、中国铝业、三峡集团、中国国电、国家电力投资集团、浙江交通投资集团等，交易金额过万亿元。公司的企业市场占比大幅领先于行业第二名。</p>-->
        <!--        <p>易招标的自运营平台“招采进宝” 是国内首屈一指的电子化交易平台，是我国首批试点、首批接入国家招标投标公共服务平台、首家通过最高级别三星认证、首批接入第三方交易平台体系，2020年财政部推荐的第一家总部在京外的第三方交易平台。该平台支持招、投、开、评、定、合同履行，具有远程评审功能，支持在线述标、答疑，规范采购流程、强化采购过程管控，并对过程文件实现数据化，可为企业决策提供实时、准确的数据支持，最终降低成本、提高采购效率，帮助企业确立供应链竞争优势。</p>-->
        <!--        <div>-->
        <!--          <img :src="$images.login_background" alt />-->
        <!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import announcement from "@/api/announcement/announcement"
export default {
  created () {
    this.queryBannerListByPosition()
    announcement.queryCompanyProfile().then(res => {
        if (res.code == 0){
          this.chContent = res.data.description
        }
      }
    )
    
  },
  mounted () {
    // this.$refs.chContent.innerHTML=this.chContentz
  },
  data () {
    return {
      imgUrl: null,
      chContent: null,
      banners: [],
    }
  },
  methods: {
    // logoIcon: require("@/assets/images/logo.png"),
    onLogo () {
      this.$router.push("/")
    },
    //获取banner
    queryBannerListByPosition () {
      console.log('aa')
      announcement.queryBannerListByPosition({ position: 'home' }).then(res => {
        console.log(res)
        this.banners = res.data
      })
    },
    //banner跳转
    isSkip(data){
      console.log("点击banner" + data)
      if(data.isSkip == 0) {
        return false
      } else if(data.isSkip == 1) {
        this.$router.push({path: data.skipUrl})
      } else {
        window.location.href = data.skipUrl 
      }
    },
  }
}
</script>
<style lang="less" scoped>
.ch-main {
  margin: -20px;
  background-color: #ffffff;
  border-bottom: 1px solid #efefef;
}
.ch-title {
  color: #333333;
  font-size: 24px;
  padding: 15px 0;
  text-align: center;
  position: relative;
  margin-top: 25px;
}
.ch-title::after {
  content: "";
  display: block;
  height: 2px;
  background-color: #3984f7;
  width: 41px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.ch-content {
  font-size: 16px;
  color: #333333;
  font-size: 16px;
  font-weight: 300;
  color: #333333;
  line-height: 28px;
  padding: 25px 0;
  margin-bottom: 15px;
  img {
    max-width: 100%;
  }
}
</style>